import * as React from 'react';

import { Row } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as conversationListState from '../_state/conversationList.state';

import { ConversationListPanel } from './ConversationListPanel';
import { ConversationCurrent } from './CurrentConversation';
import { NoConversation } from './NoConversation';

export type BusinessChatManagerProps = {
  onClose: () => void;
};

export function ChatModule({ onClose }: BusinessChatManagerProps) {
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  const selectedConversation = useAtomValue(
    conversationListState.$selectedConversation,
  );

  return (
    <Row gap2 ref={containerRef} className="@ChatModule h-full p-2" yStretch>
      {/* 🟠🟠🟠 Conversation List Panel */}
      <ConversationListPanel onClose={onClose} />

      {/* 🟠🟠🟠 Main Chat Area */}
      <div className="flex flex-1 flex-col">
        {selectedConversation && <ConversationCurrent />}
        {!selectedConversation && <NoConversation />}
      </div>
    </Row>
  );
}
